import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { createEpicMiddleware } from 'redux-observable';
import logger from 'redux-logger';
import rootEpic from '../epics/rootEpic';
import rootReducer from '../reducers';
import services from '../services';
import routerMiddleware from './middlewares/routerMiddleware';

const epicMiddleware = createEpicMiddleware({
  dependencies: services,
});
const middlewares = [thunk, routerMiddleware, epicMiddleware];

if (window?.location?.host?.includes('localhost')) {
  middlewares.push(logger);
}

const store = createStore(rootReducer, applyMiddleware(...middlewares));
epicMiddleware.run(rootEpic);

export default store;
